/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as RepoStrongRef from '../../../com/atproto/repo/strongRef.defs.js'
import * as FeedDefs from '../feed/defs.defs.js'
import * as GraphDefs from '../graph/defs.defs.js'
import * as LabelerDefs from '../labeler/defs.defs.js'
import * as ActorDefs from '../actor/defs.defs.js'
import * as LabelDefs from '../../../com/atproto/label/defs.defs.js'
import * as EmbedImages from './images.defs.js'
import * as EmbedVideo from './video.defs.js'
import * as EmbedExternal from './external.defs.js'
import * as EmbedRecordWithMedia from './recordWithMedia.defs.js'

const $nsid = 'app.bsky.embed.record'

export { $nsid }

type Main = { $type?: 'app.bsky.embed.record'; record: RepoStrongRef.Main }

export type { Main }

const main = l.typedObject<Main>(
  $nsid,
  'main',
  l.object({
    record: l.ref<RepoStrongRef.Main>((() => RepoStrongRef.main) as any),
  }),
)

export { main }

export const $isTypeOf = /*#__PURE__*/ main.isTypeOf.bind(main),
  $build = /*#__PURE__*/ main.build.bind(main),
  $type = /*#__PURE__*/ main.$type
export const $assert = /*#__PURE__*/ main.assert.bind(main),
  $check = /*#__PURE__*/ main.check.bind(main),
  $cast = /*#__PURE__*/ main.cast.bind(main),
  $ifMatches = /*#__PURE__*/ main.ifMatches.bind(main),
  $matches = /*#__PURE__*/ main.matches.bind(main),
  $parse = /*#__PURE__*/ main.parse.bind(main),
  $safeParse = /*#__PURE__*/ main.safeParse.bind(main),
  $validate = /*#__PURE__*/ main.validate.bind(main),
  $safeValidate = /*#__PURE__*/ main.safeValidate.bind(main)

type View = {
  $type?: 'app.bsky.embed.record#view'
  record:
    | l.$Typed<ViewRecord>
    | l.$Typed<ViewNotFound>
    | l.$Typed<ViewBlocked>
    | l.$Typed<ViewDetached>
    | l.$Typed<FeedDefs.GeneratorView>
    | l.$Typed<GraphDefs.ListView>
    | l.$Typed<LabelerDefs.LabelerView>
    | l.$Typed<GraphDefs.StarterPackViewBasic>
    | l.Unknown$TypedObject
}

export type { View }

const view = l.typedObject<View>(
  $nsid,
  'view',
  l.object({
    record: l.typedUnion(
      [
        l.typedRef<ViewRecord>((() => viewRecord) as any),
        l.typedRef<ViewNotFound>((() => viewNotFound) as any),
        l.typedRef<ViewBlocked>((() => viewBlocked) as any),
        l.typedRef<ViewDetached>((() => viewDetached) as any),
        l.typedRef<FeedDefs.GeneratorView>(
          (() => FeedDefs.generatorView) as any,
        ),
        l.typedRef<GraphDefs.ListView>((() => GraphDefs.listView) as any),
        l.typedRef<LabelerDefs.LabelerView>(
          (() => LabelerDefs.labelerView) as any,
        ),
        l.typedRef<GraphDefs.StarterPackViewBasic>(
          (() => GraphDefs.starterPackViewBasic) as any,
        ),
      ],
      false,
    ),
  }),
)

export { view }

type ViewRecord = {
  $type?: 'app.bsky.embed.record#viewRecord'
  uri: l.AtUriString
  cid: l.CidString
  author: ActorDefs.ProfileViewBasic

  /**
   * The record data itself.
   */
  value: l.LexMap
  labels?: LabelDefs.Label[]
  replyCount?: number
  repostCount?: number
  likeCount?: number
  quoteCount?: number
  embeds?: (
    | l.$Typed<EmbedImages.View>
    | l.$Typed<EmbedVideo.View>
    | l.$Typed<EmbedExternal.View>
    | l.$Typed<View>
    | l.$Typed<EmbedRecordWithMedia.View>
    | l.Unknown$TypedObject
  )[]
  indexedAt: l.DatetimeString
}

export type { ViewRecord }

const viewRecord = l.typedObject<ViewRecord>(
  $nsid,
  'viewRecord',
  l.object({
    uri: l.string({ format: 'at-uri' }),
    cid: l.string({ format: 'cid' }),
    author: l.ref<ActorDefs.ProfileViewBasic>(
      (() => ActorDefs.profileViewBasic) as any,
    ),
    value: l.lexMap(),
    labels: l.optional(
      l.array(l.ref<LabelDefs.Label>((() => LabelDefs.label) as any)),
    ),
    replyCount: l.optional(l.integer()),
    repostCount: l.optional(l.integer()),
    likeCount: l.optional(l.integer()),
    quoteCount: l.optional(l.integer()),
    embeds: l.optional(
      l.array(
        l.typedUnion(
          [
            l.typedRef<EmbedImages.View>((() => EmbedImages.view) as any),
            l.typedRef<EmbedVideo.View>((() => EmbedVideo.view) as any),
            l.typedRef<EmbedExternal.View>((() => EmbedExternal.view) as any),
            l.typedRef<View>((() => view) as any),
            l.typedRef<EmbedRecordWithMedia.View>(
              (() => EmbedRecordWithMedia.view) as any,
            ),
          ],
          false,
        ),
      ),
    ),
    indexedAt: l.string({ format: 'datetime' }),
  }),
)

export { viewRecord }

type ViewNotFound = {
  $type?: 'app.bsky.embed.record#viewNotFound'
  uri: l.AtUriString
  notFound: true
}

export type { ViewNotFound }

const viewNotFound = l.typedObject<ViewNotFound>(
  $nsid,
  'viewNotFound',
  l.object({ uri: l.string({ format: 'at-uri' }), notFound: l.literal(true) }),
)

export { viewNotFound }

type ViewBlocked = {
  $type?: 'app.bsky.embed.record#viewBlocked'
  uri: l.AtUriString
  blocked: true
  author: FeedDefs.BlockedAuthor
}

export type { ViewBlocked }

const viewBlocked = l.typedObject<ViewBlocked>(
  $nsid,
  'viewBlocked',
  l.object({
    uri: l.string({ format: 'at-uri' }),
    blocked: l.literal(true),
    author: l.ref<FeedDefs.BlockedAuthor>(
      (() => FeedDefs.blockedAuthor) as any,
    ),
  }),
)

export { viewBlocked }

type ViewDetached = {
  $type?: 'app.bsky.embed.record#viewDetached'
  uri: l.AtUriString
  detached: true
}

export type { ViewDetached }

const viewDetached = l.typedObject<ViewDetached>(
  $nsid,
  'viewDetached',
  l.object({ uri: l.string({ format: 'at-uri' }), detached: l.literal(true) }),
)

export { viewDetached }
